import { Mail } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { TEAM } from "@/i18n";

export const Team = ({ t, lang }) => {
  const suffix = { de: "De", en: "En", sh: "Sh", hi: "Hi" }[lang] || "En";
  return (
  <section id="team" data-testid="team-section" className="relative py-24 sm:py-32 px-4">
    <div className="max-w-7xl mx-auto">
      <Reveal className="max-w-3xl">
        <Eyebrow>{t.team.label}</Eyebrow>
        <h2 className="mt-4 font-jakarta text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
          {t.team.title}
        </h2>
        <p className="mt-5 text-base text-slate-600 leading-relaxed">{t.team.sub}</p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {TEAM.map((member, i) => (
          <Reveal key={member.key} delay={(i % 3) * 0.1}>
            <div
              data-testid={`team-card-${member.key}`}
              className="group relative rounded-2xl bg-surface border border-slate-200 overflow-hidden hover:border-[#003940]/50 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-xl"
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={member.image}
                  alt={member[`name${suffix}`]}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-surface via-transparent to-transparent" />
              </div>
              <div className="p-6">
                <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#003940]">
                  {member[`role${suffix}`]}
                </p>
                <h3 className="mt-2 text-xl font-semibold tracking-tight text-slate-900">{member[`name${suffix}`]}</h3>
                {member.key === "geschaeftsfuehrung" ? (
                  <a
                    href={`mailto:${member.email}`}
                    data-testid={`team-email-${member.key}`}
                    className="mt-4 inline-flex items-center gap-2 text-[#003940] hover:text-[#002A2F] font-mono text-sm underline underline-offset-4 transition-colors"
                  >
                    <Mail size={15} />
                    {member.email}
                  </a>
                ) : (
                  <a
                    href="#kontakt"
                    data-testid={`team-cta-${member.key}`}
                    className="mt-4 inline-flex items-center justify-center gap-2 rounded-full bg-[#003940] hover:bg-[#002A2F] text-white px-5 py-2.5 text-sm font-semibold transition-colors"
                  >
                    <Mail size={15} />
                    {t.nav.cta}
                  </a>
                )}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
